import { createSelectionListViewContainer } from 'factories/SelectionListView'
import unitsOfMeasureActions from 'actions/unitsOfMeasure'
import Component from 'components/Requisitions/Items/FormView/SelectUnitOfMeasure'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: () => dispatch(unitsOfMeasureActions.getOptionsOffline()),
  }),
})(Component)
